<template>
  <div>
    <el-dialog
      :title="payApprovePayType == 2 ? '线上结算付款审批' : '财务付款审批'"
      :visible.sync="payVisible"
      :before-close="onClose"
      :close-on-click-modal="false"
      :destroy-on-close="true"
    >
      <el-alert
        :title="
          payApprovePayType == 2
            ? '已选中' + statementIdsLength + '张结算单，结算打款需进行审批，审批通过后将自动发放劳务费至调查员账户'
            : '支付审批可以添加多名审批人，审批通过后结算单将变为「已打款」状态'
        "
        type="success"
      >
      </el-alert>
      <el-form :model="ruleForm" ref="ruleForm" label-width="180px" class="demo-ruleForm" :rules="rules">
        <el-form-item label="申请人：" prop="name">
          {{ userName }}
        </el-form-item>
        <el-form-item :label="payApprovePayType == 2 ? '结算金额（元)：' : '劳务费结算税前金额 (元)：'" prop="money">
          <span class="text-red">{{ payAmount }}</span>
        </el-form-item>
        <el-form-item label="审批人：" prop="auditor" :show-message="false">
          <dygc-user is-order :value="disableList" @input="getInputList" ref="dygcUser" />
          <!-- <div style="max-height: 600px" class="overflow-y-auto">
            <el-tree
                ref="userTree"
                :data="auditList"
                :props="props"
                node-key="id"
                show-checkbox
                @check="handleCheckChange"
                empty-text="暂无角色"
            />
          </div> -->
          <ul class="audit-groups">
            <li class="audit-item" v-for="(user, index) in checkedAuditUsers" :key="user.id">
              <!-- <el-popover
                  placement="bottom"
                  trigger="click"
              >
                <template v-slot:default>
                  <div class="text-center">
                    <el-button @click="onClickDelAuditUser(index)">删除</el-button>
                  </div>
                </template> -->
              <!-- <el-button type="text" slot="reference"> -->
              <span class="del-icon">
                {{ user.name }}
                <i class="el-icon-error mx-1 cursor-pointer opacity-0" @click="onClickDelAuditUser(index)"></i>
              </span>
              <!-- </el-button> -->
              <!-- </el-popover> -->
            </li>
          </ul>
        </el-form-item>
        <!-- <el-form-item required label="终审管理员：" prop="finalManager">
          <el-select v-model="ruleForm.finalManager">
            <el-option
                v-for="manager in businessManager"
                :key="manager.id"
                :value="manager.id"
                :label="manager.name"
            />
          </el-select>
          <p>{{ finalManagerName }}</p>
        </el-form-item> -->
        <!-- <el-form-item v-if="payApprovePayType == 2" label="付款人：" prop="payer" :show-message="false">
          <el-select v-model="ruleForm.payer" filterable placeholder="请选择">
            <el-option v-for="item in payerList" :key="item.id" :label="item.name + '-' + item.mobile" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item v-if="payApprovePayType==2" label="付款人：" prop="payer" :show-message="false">
          <dygc-user is-order :value="disablePayerList" :isSingle="true" :multiple="false" @input="getInputPayerList" ref="dygcUserPayer"/>
        </el-form-item>
        <el-form-item label="备注：" prop="desc" :show-message="false">
          <el-input placeholder="请输入" type="textarea" v-model="ruleForm.desc" @change="descChange()"></el-input>
        </el-form-item>
        <el-form-item>
          <el-row class="btnGroup">
            <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
            <el-button @click="onClose">取消</el-button>
          </el-row>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { getDygcManage } from '@/api/wenjuan/user'
import { submitApproval } from '@/api/pay/approval'
import { initDygcUser, getDygcAllUser, adoptKeyToUserId, getCurrentTreeUserNode } from '@/assets/js/dygc-util'
import { initPaySettlement, getStaffForPay } from '@/api/wenjuan/settlement'
import { getStore } from '@dygc/shared'
import DygcUser from '@/components/dygc-user/DygcUser'
import GlobalConfig from '@/global/config'

export default {
  components: { DygcUser },
  props: {
    paymentInfo: {
      type: Object,
      default: () => ({})
    },
    visible: {
      type: Boolean,
      default: ''
    },
    payApprovePayType: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      companyId: GlobalConfig.getCompanyId(),
      payAmount: '',
      companyUser: null,
      disableList: [],
      disablePayerList:[],
      businessManager: [], // 管理员列表
      auditList: [],
      ruleForm: {
        finalManager: '', // 终审管理员id
        name: '',
        region: '',
        auditor: '',
        peo2: '',
        desc: '',
        // payer: ''
      },
      mineStatus: '',
      visSelectVal: '',
      selectVal: '',
      selectVal1: '',
      mineStatusValue: [],
      data: [],
      props: {
        label: 'name',
        children: 'children'
      },
      checkedKeys: [], // 选择的审核员
      checkedAuditUsers: [],
      checkedPayer:[],
      rules: {
        // auditor: [
        //   { required: true, message: '审批人必填', trigger: 'blur' }
        // ],
        desc: [{ required: true, message: '', trigger: 'change' }],
        // payer: [{ required: true, message: '', trigger: 'change' }]
      },
      // payerList: []
    }
  },
  created() {
    this.initApprovalUser()
  },
  watch: {
    visible(v) {
      if (v) {
        // this.getStaffForPay()
        this.$refs.dygcUser?.clearCheckedNodes()
        this.$refs.dygcUserPayer?.clearCheckedNodes()
        if (this.paymentInfo.bach == 'bach') {
          this.payAmount = parseFloat(this.paymentInfo.sheetAmountSum).toFixed(2)
        } else {
          this.payAmount = this.paymentInfo.sheetAmount
        }
      } else {
        this.checkedAuditUsers = []
        this.checkedPayer = []
        this.payAmount = null
      }
    }
  },
  computed: {
    payVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },
    finalManagerName() {
      let result = this.businessManager.find(manage => manage.id === this.ruleForm.finalManager)
      if (!result) return ''
      return result.name
    },
    userName() {
      let userInfo = this.userInfo
      return (userInfo.dygcStaffName || '') + (userInfo.phone ? '-' + userInfo.phone : '')
    },
    statementIdsLength() {
      return this.paymentInfo.sentData?.statementIds.length || 0
    },
    ...mapGetters(['userInfo'])
  },
  methods: {
    descChange() {
      this.$nextTick(() => {
        this.$refs['ruleForm'].clearValidate()
      })
    },
    getInputList(value) {
      this.disableList = value
      this.checkedAuditUsers = value
    },
    getInputPayerList(value){
      if((value.length && this.checkedPayer.length) || value.length > 1){
        this.$message.error('只能选择一个付款人')
        value.forEach(item => {
          if(this.checkedPayer.length){
            if(JSON.stringify(this.checkedPayer[0]) != JSON.stringify(item)){
              this.$refs.dygcUserPayer.setChecked(item,false)
            }
          }else{
            this.$refs.dygcUserPayer?.clearCheckedNodes()
          }
        });
        return
      }
      this.disablePayerList = value
      this.checkedPayer = value
    },
    onClickDelAuditUser(index) {
      this.checkedAuditUsers.splice(index, 1)
      this.$refs.dygcUser.$refs.userTree.setCheckedKeys(
        this.checkedAuditUsers.map(item => item.id),
        false
      )
      // // 触发审批人校验
      // this.validateCheckedAuditUsers()
    },
    // handleCheckChange(item, data) {
    //   // this.checkedAuditUsers = adoptKeyToUserId(data.checkedKeys)
    //   // return
    //   let checkedAuditUsers = this.checkedAuditUsers.slice()

    //   if (item.flag) {
    //     // 如果为 true 说明则是企业员工 直接追加到 最后
    //     checkedAuditUsers.push(item)
    //   } else {
    //     // 否则 则是企业部门
    //     let users = adoptKeyToUserId(getCurrentTreeUserNode(item, data.checkedKeys))
    //     users.forEach(user => {
    //       if (!checkedAuditUsers.some(u => u.id === user.id)) {
    //         checkedAuditUsers.push(user)
    //       }
    //     })
    //   }
    //   // 过滤掉没有选中到用户
    //   checkedAuditUsers = checkedAuditUsers.filter(user => data.checkedKeys.includes(user.id))
    //   this.checkedAuditUsers = checkedAuditUsers
    //   // 触发审批人校验
    //   if(this.checkedAuditUsers.length > 0) {
    //     this.ruleForm.auditor = '1'
    //   } else {
    //     this.ruleForm.auditor = ''
    //   }
    //   this.$refs['ruleForm'].validateField('auditor')
    // },
    validateCheckedAuditUsers() {
      // 触发审批人校验
      if (this.checkedAuditUsers.length > 0) {
        this.ruleForm.auditor = '1'
      } else {
        this.ruleForm.auditor = ''
      }
      this.$refs['ruleForm'].validateField('auditor')
    },
    initApprovalUser() {
      getDygcAllUser().then(res => {
        this.companyUser = res
        this.auditList = initDygcUser(this.companyUser)
      })
      getDygcManage().then(res => {
        this.businessManager = res.data.data
      })
    },
    submitForm(formName) {
      let ruleForm = this.$refs.ruleForm
      // if (!this.ruleForm.finalManager) {
      //   this.$message.warning('提交失败，未选择终审管理员')
      //   return
      // }
      // if(this.checkedAuditUsers && this.checkedAuditUsers.length == 0 ) {
      //   this.$message.warning('提交失败，未选择审批人')
      //   return
      // }
      if (this.payApprovePayType==2 && !this.checkedPayer.length) {
        this.$message.warning('提交失败，未选择结算审批人')
        return
      }
      if (!this.ruleForm.desc) {
        this.$message.warning('提交失败，未填写备注')
        return
      }
      let auditors = this.checkedAuditUsers.map(item => ({
        id: item.id,
        customerId: item.customerId,
        companyId: this.companyId
      }))
      // if (auditors.some(({ id }) => id === this.ruleForm.finalManager)) {
      //   this.$message.warning('审核员不能包含终审管理员')
      //   return
      // }

      let data = this.paymentInfo.sentData
      data.auditors = auditors
      data.payType = this.payApprovePayType
      data.remark = this.ruleForm.desc
      if (this.payApprovePayType == 2) {
        const payer = this.checkedPayer.map(item => ({ id: item.id, customerId: item.customerId, name: item.name, companyId: this.companyId}))
        data.payer = payer[0]
      }
      initPaySettlement(data)
        .then(res => {
          this.$message.success('已提交审批，审批通过后结算单将变为「已结算」状态')
          this.onClose()
          this.$emit('refresh')
        })
        .catch(err => {
          this.$message.error(err)
        })
    },
    resetForm(formName) {
      this.$emit('cancel')
      this.$refs[formName].resetFields()
    },
    onClose() {
      this.payVisible = false
      this.$refs['ruleForm'].resetFields()
    },
    // getStaffForPay() {
    //   getStaffForPay({ companyId: this.companyId }).then(res => {
    //     if (res.data.code != 0) {
    //       this.$message.error(res.data.msg)
    //       return
    //     }
    //     this.payerList = res.data.data
    //   })
    // }
  }
}
</script>
<style lang="scss" scoped>
@import '~@/assets/scss/envelopes.scss';

.show-head,
.show-body {
  @apply w-full flex justify-between;
  span {
    @apply flex-1 leading-9 text-center;
  }
}

.settlement {
  .show-sum {
    margin-top: 30px;
    text-align: right;
  }
}
</style>
<style lang="scss" scoped>
.audit-groups {
  .audit-item {
    @apply inline-block;
    margin-right: 10px;

    &::after {
      content: ' ';
      display: inline-block;
      width: 8px;
      height: 8px;
      border: 1px solid #000;
      border-left: none;
      border-bottom: none;
      transform: rotate(45deg);
    }

    &:last-child {
      &::after {
        content: '';
        width: 0;
        height: 0;
      }
    }
  }
}

.demo-ruleForm {
  width: 600px;
  margin: auto;

  .btnGroup {
    margin-left: 60px;
    margin-bottom: 30px;
  }
}
.el-form-item.is-error ::v-deep.el-textarea__inner,
.el-form-item.is-error ::v-deep.el-textarea__inner:focus {
  border-color: #dcdfe6;
}
::v-deep .el-select {
  width: 100% !important;
}
.del-icon:hover {
  .el-icon-error {
    opacity: 1;
  }
}
</style>
